// extracted by mini-css-extract-plugin
export default {"ContentContainerStyle":"v3c7jlajfjQPtjxsE8RJDQ=="};